import { MaterialTypeDto } from './material-type.dto';

export class MaterialType {
    readonly id: string;
    readonly code: string;
    readonly name: string;

    constructor(dto: MaterialTypeDto) {
        this.id = dto.id;
        this.code = dto.code;
        this.name = dto.name;
    }
}
